import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { mergeMap, take } from "rxjs/operators";

import { MarketModel } from "../models/market.model";
import { DataService } from "../services/data/data.service";
import { SaleService } from "../services/sale/sale.service";

@Injectable({
  providedIn: "root"
})
export class MarketResolverService implements Resolve<MarketModel> {
  constructor(private dataService: DataService, private saleService:SaleService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<MarketModel> | Observable<never> {
    const id = route.paramMap.get("marketId");
    const status = route.paramMap.get("status") || "open";
    // console.log('market resolver id', id);
    if (id == undefined) {
      const date = new Date();
      date.setDate(date.getDate()+7);
      const dateIso = date.toISOString();
      const newItem = <MarketModel>{
        details: {
          datesPlaces:[{
            date:dateIso,
            geocoding:{
              address:{}
            },
            moment: 'morning',
            fromTimeHour:'08:00',
            toTimeHour:'12:00',
          }],
          currency: "EUR",
          format: "group",
          recurrence: "weekly",
          frequency:1,
          ordersVisible: false,
          singleOrder: true,
          deliveryType:'market',
          deliveryCost:0,
          opening:6,
          closing:1
        },
        status: "new",
        applicationStatus:"open",
        producers: {},
        tournees: {},
        finances: {
          producerCount: 0
        },
        notifications:{
          config:['producer','sale','place'],
        }
      };
      return of(newItem);
    } else {
      return this.dataService.getMarket(id).pipe(
        take(1),
        mergeMap(item => {
          if (item && Object.keys(item).length > 1) {
            item.details.datesPlaces = this.saleService.getDatesPlaces(item.details);
            return of(item);
          }
        })
      );
    }
  }
}
